import { getCookie } from 'cookies-next/client';

import { COOKIES } from '@/shared/constants/cookies';

export const isInMobileApp = () => Boolean(getCookie(COOKIES.IN_MOBILE_APP));
